module.exports = __webpack_public_path__ + "static/media/roses.723c93f6.jpg";